import React, { useEffect, useState } from "react";
import HeaderSocialLinks from "./HeaderSocialLinks";
import { headerSocialLinksArray } from "../data/HeaderSocialLinksData";

const MainNavLinks = () => { 

    const addActiveMenuClass = (menuLabel) => {
        let isActive = false;
        const urlPathName = window.location.href.split('/').pop();
        if(urlPathName !== "") {
            if(menuLabel.indexOf(urlPathName) !== -1) {
                isActive = true;
            }
            else {
                isActive = false;
            }
        }
        //console.log(urlPathName);
        return isActive;
    }

    const MenuItem = (props) => {
        const isActiveLink = addActiveMenuClass(props.className);
        return (
            <li className={isActiveLink ? props.className + " active" : props.className}>
                <a href={props.href}>
                    <span>{props.label}</span>
                </a>
            </li>
        )
    }

    const onOpenClick = (e) => {
        let rootEl = document.getElementById('root');
        const leftSideNav = document.querySelector('.left-side-nav');
        const navClass = localStorage.getItem('navClass');
        if(navClass && navClass === 'expand-left-nav') {
            localStorage.removeItem('navClass');
            leftSideNav.classList.remove('expand-left-nav');
            document.querySelector('#root').classList.remove('sgt-menu-open');
        }
        else {
            localStorage.setItem('navClass', 'expand-left-nav');
        }
        rootEl.classList.add('sgt-menu-open');
        if(rootEl && rootEl.className.indexOf('sgt-menu-open') !== -1 && !navClass) {
           // rootEl.classList.remove('sgt-menu-open');
            if(leftSideNav) {
                leftSideNav.classList.add('expand-left-nav');
            }
        }
        else {
            if(leftSideNav) {
                leftSideNav.classList.remove('expand-left-nav');
                document.querySelector('#root').classList.remove('sgt-menu-open');
            }  
        }
    }

    // useEffect(() => {
    //     addActiveMenuClass();
    // }, [])

    return (
        <div className="main-nav">
            <span className="open-mob-menu" onClick={onOpenClick}></span>
            <nav>
                <ul>
                    {/* <li>
                        <a href="/">
                            Home
                        </a>
                    </li> */}
                    <MenuItem className="desktop blue-txt" href="/" label="SHILLGUARD" />
                    <MenuItem className="menu-signals" href="/signals" label="Signals" />
                    <MenuItem className="menu-calls" href="/calls" label="Call Groups" />
                    <MenuItem className="menu-news" href="/news" label="Crypto News" />
                    <MenuItem className="menu-ourtoken" href="/ourtoken" label="Our Token" />
                    <MenuItem className="menu-premiumplans" href="/premiumplans" label="Premium Plans" />
                    {/* <li className="menu-ourtoken">
                        <a href="/ourtoken">
                            <span></span>
                        </a>
                        <ul>
                            <li className="menu-staking">
                                <a href="/staking">
                                    <span>Staking</span>
                                </a>
                            </li>
                        </ul>
                    </li> */}
                    <MenuItem className="menu-TelegramApp" href="/TelegramApp" label="Telegram App" />
                    <MenuItem className="menu-TelegramBots" href="/TelegramBots" label="Telegram Bots" />
                    {/* <li className="menu-TelegramBots">
                        <a href="/TelegramBots">
                            <span></span>
                        </a>
                        <ul>
                            <li className="menu-ShillDetectBot">
                                <a href="/ShillDetectBot">
                                    <span>Shill Detect Bot</span>
                                </a>
                            </li>
                            <li className="menu-ShillNewsBot">
                                <a href="/ShillNewsBot">
                                    <span>Shill News Bot</span>
                                </a>
                            </li>
                        </ul>
                    </li> */}
                    <MenuItem className="menu-about" href="/about" label="About Us" />
                    <MenuItem className="menu-team" href="/team" label="Team" />
                    <MenuItem className="menu-roadmap" href="/roadmap" label="RoadMap" />
                    {/* <li className="menu-about">
                        <a href="/about">
                            <span></span>
                        </a>
                        <ul>
                            <li className="menu-team">
                                <a href="/team">
                                    <span>Team</span>
                                </a>
                            </li>
                            <li className="menu-roadmap">
                                <a href="/roadmap">
                                    <span>RoadMap</span>
                                </a>
                            </li>
                            <li className="menu-partners">
                                <a href="/partners">
                                    <span>Partners</span>
                                </a>
                            </li>
                        </ul>
                    </li> */}
                    {/* <li>
                        <a href="/whyshillguard">
                            Why Shillguard 
                        </a>
                    </li> */}
                    {/* <li>
                        <a href="/whatsnext">
                            What's Next
                        </a>
                    </li> */}
                    {/* <li>
                        <a href="/vision">
                            Our Vision and Road Ahead
                        </a>
                    </li> */}
                    {/* <li>
                        <a href="/vision2">
                            Our Vision and Road Ahead 2
                        </a>
                    </li> */}
                </ul>
            </nav>
            

            {/* <a href="/">
                <span role="img" aria-label="about us">💁🏻‍♂️</span>
                About us
            </a>
            <a href="/">
                <span role="img" aria-label="price">💸</span>
                Pricing
                </a>
            <a href="/">
                <span role="img" aria-label="contact">📩</span>
                Contact
            </a> */}
            <div className="main-nav-social">
                <HeaderSocialLinks links={headerSocialLinksArray} leftNav={true} />
            </div>
            <nav className="toggle-left-menu">
                <ul>
                    <li onClick={onOpenClick}><span className="toggle-m-btn">Expand menu</span></li>
                </ul>
            </nav>
        </div>
    )
}

export default MainNavLinks;

// const App = () => {
//   const [open, setOpen] = React.useState(false);
//   const node = React.useRef();
//   return (
//     <div>
//       <div>
//         <h1>Hello. This is burger menu tutorial</h1>
//         <img src="https://image.flaticon.com/icons/svg/2016/2016012.svg" alt="burger icon" />
//         <small>Icon made by <a href="https://www.freepik.com/home">Freepik</a> from <a href="https://www.flaticon.com">www.flaticon.com</a></small>
//        </div>
//       <div ref={node}>
//         <Burger open={open} setOpen={setOpen} />
//         <Menu open={open} setOpen={setOpen} />
//       </div>
//     </div>
//   )  
// }


// ReactDOM.render(<App />, document.getElementById('app'));

// const useOnClickOutside = (ref, handler) => {
//   React.useEffect(() => {
//     const listener = event => {
//       if (!ref.current || ref.current.contains(event.target)) {
//         return;
//       }
//       handler(event);
//     };
//     document.addEventListener('mousedown', listener);

//     return () => {
//       document.removeEventListener('mousedown', listener);
//     };
//   },
//   [ref, handler],
//   );
// };